(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voqzunir-header"]) return;
  try {
    
document.querySelectorAll('[data-vf-deadline]').forEach(timer=>{
 const end=Date.parse(timer.dataset.vfDeadline);
 if(!Number.isFinite(end)){timer.hidden=true;return;}
 const tick=()=>{const seconds=Math.max(0,Math.floor((end-Date.now())/1000));const h=Math.floor(seconds/3600);const m=Math.floor(seconds%3600/60);const s=seconds%60;timer.textContent=[h,m,s].map(n=>String(n).padStart(2,'0')).join(':');if(seconds===0){timer.closest('.vf-offer').hidden=true;clearInterval(interval);}};
 const interval=setInterval(tick,1000);tick();
});
document.addEventListener('click',event=>{document.querySelectorAll('.vf-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open');});});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.vf-menu[open]').forEach(menu=>menu.removeAttribute('open'));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voqzunir-product"] && !Shopify.designMode) return;
  try {
    
function initVfProduct(root){
 root.querySelectorAll('.vf-product').forEach(page=>{
  if(page.dataset.vfBound)return;page.dataset.vfBound='true';
  const select=page.querySelector('select[name="id"]');const radios=[...page.querySelectorAll('input[name="vf_package"]')];const image=page.querySelector('.vf-main-image');const thumbs=[...page.querySelectorAll('[data-vf-image]')];let imageIndex=0;
  const setImage=src=>{if(!src||!image)return;image.removeAttribute('srcset');image.src=src;};
  const update=()=>{const option=select.selectedOptions[0];if(!option)return;page.querySelectorAll('[data-vf-price]').forEach(el=>el.textContent=option.dataset.price);const old=page.querySelector('[data-vf-compare]');old.hidden=!option.dataset.compare;old.textContent=option.dataset.compare;const submit=page.querySelector('.vf-add');submit.disabled=option.dataset.available!=='true';submit.textContent=submit.disabled?submit.dataset.unavailable:submit.dataset.label;radios.forEach(r=>r.checked=r.value===option.dataset.pack);setImage(option.dataset.image);thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.vfImage===option.dataset.image)));};
  const filter=pack=>{[...select.options].forEach(o=>{o.hidden=o.dataset.pack!==pack;});const valid=[...select.options].filter(o=>o.dataset.pack===pack&&!o.disabled);if(valid.length&&!valid.includes(select.selectedOptions[0]))select.value=valid[0].value;update();};
  radios.forEach(r=>r.addEventListener('change',()=>filter(r.value)));
  select.addEventListener('change',()=>{filter(select.selectedOptions[0].dataset.pack);const u=new URL(location.href);u.searchParams.set('variant',select.value);history.replaceState(null,'',u.toString());});
  thumbs.forEach((button,index)=>button.addEventListener('click',()=>{imageIndex=index;setImage(button.dataset.vfImage);thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));}));
  page.querySelector('.vf-prev').addEventListener('click',()=>{imageIndex=(imageIndex+thumbs.length-1)%thumbs.length;thumbs[imageIndex].click();});
  page.querySelector('.vf-next').addEventListener('click',()=>{imageIndex=(imageIndex+1)%thumbs.length;thumbs[imageIndex].click();});
  if(select.selectedOptions[0])filter(select.selectedOptions[0].dataset.pack);
 });
}
initVfProduct(document);
document.addEventListener('shopify:section:load',event=>initVfProduct(event.target));

  } catch(e) { console.error(e); }
})();
})();
